import { render, staticRenderFns } from "./ProductoPresentacionesProcessAdmin.vue?vue&type=template&id=315fc9ab&scoped=true&"
import script from "./ProductoPresentacionesProcessAdmin.vue?vue&type=script&lang=js&"
export * from "./ProductoPresentacionesProcessAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProductoPresentacionesProcessAdmin.vue?vue&type=style&index=0&id=315fc9ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315fc9ab",
  null
  
)

export default component.exports